export enum Popup {
  SCOREBOARD = 'SCOREBOARD',
  WINNER = 'WINNER',
}
